import React from "react";
import { CustomTag } from "./Tag.styles";
import { SizeStyles } from "./Tag.variants";
import { useTheme, ChipProps as MuiChipProps } from "@mui/material";
import { Icon } from "../../icons";

type PickMuiTagProps = Pick<MuiChipProps, "label" | "disabled">;

export interface CustomVariantTagProps extends PickMuiTagProps {
  size?: "sm" | "md" | "lg";
  isActive?: boolean;
  isControlled?: boolean;
  onClick?: () => void;
  onDelete?: () => void;
}

export const Tag = ({
  onClick,
  onDelete,
  size = "md",
  isActive,
  isControlled = false,
  ...rest
}: CustomVariantTagProps) => {
  const [isTagActiveInternal, setTagActiveInternal] = React.useState(
    isControlled && (isActive ?? false)
  );

  const theme = useTheme();
  const sizeStylesFn = SizeStyles(theme);

  const handleClick = () => {
    if (!isTagActiveInternal) {
      setTagActiveInternal(true);

      if (onClick) {
        onClick();
      }
    } else {
      handleDelete();
    }
  };

  const handleDelete = () => {
    setTagActiveInternal(false);

    if (onDelete) {
      onDelete();
    }
  };

  return (
    <CustomTag
      sx={{
        ...sizeStylesFn[size],
      }}
      onClick={handleClick}
      onDelete={
        (!isControlled && isTagActiveInternal) || (isControlled && isActive)
          ? handleDelete
          : undefined
      }
      deleteIcon={<Icon icon="X" size="sm" />}
      className={
        (!isControlled && isTagActiveInternal) || (isControlled && isActive)
          ? "active"
          : ""
      }
      {...rest}
    />
  );
};

export interface TagProps extends React.ComponentProps<typeof Tag> {
  as?: React.ElementType;
}

Tag.displayName = "Tag";
